import { render, staticRenderFns } from "./ot-duration-selection.vue?vue&type=template&id=304a0931&scoped=true&"
import script from "./ot-duration-selection.vue?vue&type=script&lang=ts&"
export * from "./ot-duration-selection.vue?vue&type=script&lang=ts&"
import style0 from "./ot-duration-selection.vue?vue&type=style&index=0&id=304a0931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a0931",
  null
  
)

export default component.exports